/* @flow */

import * as React from 'react';
import { translate } from 'react-i18next';

import SiteAddress from 'components/SiteAddress/SiteAddress';

const LocationDetails: Function = (props: Object): React.Element<*> => {
  const {
    title,
    details,
    deliveryAddress,
    t,
  }: { title: string, details: Object, t: Function } = props;

  let siteAndCountry;
  const mergedLocation = {
    building: details && !deliveryAddress ? details.building || details.hierarchy.building : {},
    company: details && !deliveryAddress ? details.company || details.hierarchy.company : {},
    room: details && !deliveryAddress ? details.room || details.hierarchy.room : {},
    site: details && !deliveryAddress ? details.site || details.hierarchy.site : {},
    workspace: details && !deliveryAddress ? details.workspace || details.hierarchy.workspace : {},
  };

  if (deliveryAddress) {
    mergedLocation.company.name = details.delivery_customer;
    siteAndCountry = {
      address_1: details.delivery_address1,
      address_2: details.delivery_address2,
      address_3: details.delivery_address3,
      address_5: details.delivery_address5,
      postcode: details.delivery_postcode,
      country_name: details.delivery_address4,
    };
  } else {
    siteAndCountry = {
      ...{ country_name: mergedLocation.site.country_name },
      ...mergedLocation.site.address,
    };
  }

  return (
    <section>
      <h3>{title}</h3>
      <table>
        <tbody>
          <tr>
            <td>
              <b>{t('general:company')}:</b>
            </td>
            {Object.keys(mergedLocation.company).length > 0 ? (
              mergedLocation.company.name || mergedLocation.company.name === null ? (
                <td>{mergedLocation.company.name}</td>
              ) : (
                <td>{mergedLocation.company}</td>
              )
            ) : (
              <td>-</td>
            )}
          </tr>
          {Object.keys(mergedLocation.site).length > 0 && (
            <tr>
              <td>
                <b>{t('general:locations.labels.site')}:</b>
              </td>
              <td>{mergedLocation.site.name}</td>
            </tr>
          )}
          <tr>
            <td>
              <b>{t('general:locations.labels.site_address')}:</b>
            </td>
            <td>
              <SiteAddress {...siteAndCountry} />
            </td>
          </tr>
          {Object.keys(mergedLocation.building).length > 0 && (
            <tr>
              <td>
                <b>{t('general:locations.labels.building_transport')}:</b>
              </td>
              <td>{mergedLocation.building.name}</td>
            </tr>
          )}
          {Object.keys(mergedLocation.room).length > 0 && (
            <tr>
              <td>
                <b>{t('general:locations.labels.lab_room')}:</b>
              </td>
              <td>{mergedLocation.room.name}</td>
            </tr>
          )}
          {Object.keys(mergedLocation.workspace).length > 0 && (
            <tr>
              <td>
                <b>{t('general:locations.labels.system_workspace')}:</b>
              </td>
              <td>{mergedLocation.workspace.name}</td>
            </tr>
          )}
          {details && details.contact_phone && (
            <tr>
              <td>
                <b>{t('general:labels.contact_phone_number')}:</b>
              </td>
              <td>{details.contact_phone}</td>
            </tr>
          )}
          {details && details.contact_fax && (
            <tr>
              <td>
                <b>{t('general:labels.contact_fax_number')}:</b>
              </td>
              <td>{details.contact_fax}</td>
            </tr>
          )}
          {details && details.contact && (
            <tr>
              <td>
                <b>{t('general:locations.labels.contact')}:</b>
              </td>
              <td>{details.contact}</td>
            </tr>
          )}
        </tbody>
      </table>
      {Object.keys(mergedLocation.workspace).length > 0 &&
        details.asset &&
        Object.keys(details.asset).length > 0 && (
          <table>
            <tbody>
              <tr>
                <td>
                  <h3>{t('general:assets.labels.assetised_location')}</h3>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <b>{t('general:assets.labels.serial_number')}:</b>
                </td>
                <td>{details.asset.er_serial_number}</td>
              </tr>
              <tr>
                <td>
                  <b>{t('general:assets.labels.barcode_number')}:</b>
                </td>
                <td>{details.asset.barcode_number}</td>
              </tr>
              <tr>
                <td>
                  <b>{t('general:assets.labels.number')}:</b>
                </td>
                <td>{details.asset.asset_number}</td>
              </tr>
              <tr>
                <td>
                  <b>{t('general:assets.labels.description')}:</b>
                </td>
                <td>{details.asset.description}</td>
              </tr>
              <tr>
                <td>
                  <b>{t('general:asset_type')}:</b>
                </td>
                <td>{details.asset.type}</td>
              </tr>
            </tbody>
          </table>
        )}
    </section>
  );
};

export default translate()(LocationDetails);
